// To create a new swiper, change the JS variables (after const) and the variable inside newSwiper()

let swiperAutoSwipe;
let swiperProductPage;
let swiperTestimonial;
let swiperProductGrid;
let swiperSingleRow;
let swiperProductPageThumbs;

var checkSwiper = setInterval(function() {
  if (typeof Swiper === 'function') {
    clearInterval(checkSwiper);

    // Basic swiper + all controls + each swipe is not 1 slide (depends on image width)
    // Used in: json product slider section
    swiperAutoSwipe = new Swiper('.swiper-auto-swipe', {
      slidesPerView: 'auto',
      spaceBetween: 0,
      navigation: {
        nextEl: '.swiper-auto-swipe .swiper-button-next',
        prevEl: '.swiper-auto-swipe .swiper-button-prev',
      },
      scrollbar: {
        el: '.swiper-auto-swipe .swiper-scrollbar',
        hide: false,
      }
    });

    // Product page swiper thumbs
    swiperProductPageThumbs = new Swiper('.swiper-product-page-thumbs', {
      spaceBetween: 6,
      slidesPerView: 5,
      navigation: {
        nextEl: '.swiper-product-page-thumbs .swiper-button-next',
        prevEl: '.swiper-product-page-thumbs .swiper-button-prev',
      },
      breakpoints: {
        750: {
          slidesPerView: 8,
        },
      }
    });

    setTimeout(function() {
      const el = document.querySelector('.swiper-product-page-thumbs');
      if (el) {
        el.style.display = null;
      }
    }, 300);

    // Product page swiper
    // This instance is referenced in other JS, do not reuse
    swiperProductPage = new Swiper('.swiper-product-page', {
      slidesPerView: 'auto',
      pagination: {
        el: '.swiper-pagination',
        type: 'bullets',
        dynamicBullets: true,
        dynamicMainBullets: 7,
      },
      navigation: {
        nextEl: '.swiper-product-page .swiper-button-next',
        prevEl: '.swiper-product-page .swiper-button-prev',
      },
      scrollbar: {
        el: '.swiper-product-page .swiper-scrollbar',
        hide: false,
      },
      thumbs: {
        swiper: (document.querySelector('.product__media-thumbnails')) ? swiperProductPageThumbs : null,
      },
    });

    // Used in: json testimonial slider section
    swiperTestimonial = new Swiper('.testimonial-swiper', {
      spaceBetween: 60,
      slidesPerView: 1,
      centeredSlides: true,
      loop: true,
      navigation: {
        nextEl: '.testimonial-swiper .swiper-button-next',
        prevEl: '.testimonial-swiper .swiper-button-prev',
      },
      pagination: {
        el: ".testimonial-swiper .swiper-pagination",
      },
    });

    // Used in: card-grid (multiple)
    swiperProductGrid = new Swiper('.card-grid-swipe-on-mobile', {
      slidesPerView: 'auto',
      spaceBetween: 0,
      breakpoints: {
        750: {
          enabled: false
        }
      }
    });

    // Used in: json features block section, json logo list section
    swiperSingleRow = new Swiper('.swiper-single-row', {
      direction: 'horizontal',
      slidesPerView: 'auto',
      spaceBetween: 0, 
      freeMode: true
    });

    // Used in: hero carousel
    swiperTestimonial = new Swiper('.hero-auto-swipe-loop', {
      slidesPerView: 1,
      centeredSlides: true,
      loop: true,
      autoplay: {
        delay: 5000,
      },
      pagination: {
        el: ".hero-auto-swipe-loop .swiper-pagination",
        clickable: true,
      },
    });
  
  }
}, 1000);